/**
 * Trainer-level validation helpers shared between the Settings input,
 * the Portal level row, and the PATCH /api/auth/me wire-up.
 *
 * Pokémon GO has historically raised the cap (40 → 50 → 80). Current
 * cap is 80 (2025). The empty string is treated as "no value" — used
 * to clear the column server-side via { trainer_level: null }.
 */
export const TRAINER_LEVEL_MIN = 1;
export const TRAINER_LEVEL_MAX = 80;

export type TrainerLevelValidation =
  | { ok: true; value: number | null }
  | { ok: false; reason: string };

export function validateTrainerLevelInput(raw: string): TrainerLevelValidation {
  const trimmed = raw.trim();
  if (trimmed === "") return { ok: true, value: null };
  if (!/^\d+$/.test(trimmed)) {
    return { ok: false, reason: "Trainer level must be a whole number." };
  }
  const n = Number.parseInt(trimmed, 10);
  if (!Number.isFinite(n) || n < TRAINER_LEVEL_MIN || n > TRAINER_LEVEL_MAX) {
    return {
      ok: false,
      reason: `Trainer level must be between ${TRAINER_LEVEL_MIN} and ${TRAINER_LEVEL_MAX}.`,
    };
  }
  return { ok: true, value: n };
}
